import { Box, CircularProgress, Backdrop } from "@mui/material";
import { styled, keyframes } from "@mui/material/styles";

const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const StyledSpinnerContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.spacing(2),
}));

const StyledCircularProgress = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.primary.main,
  animation: `${pulse} 2s ease-in-out infinite`,
  "& .MuiCircularProgress-circle": {
    strokeLinecap: "round",
  },
}));

const LoadingText = styled(Box)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 600,
  fontSize: "1.1rem",
  textAlign: "center",
}));

interface Props {
  message?: string;
}

export const Spinner = ({ message = "Loading..." }: Props) => {
  return (
    <Backdrop
      open={true}
      sx={{
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        backdropFilter: "blur(5px)",
        zIndex: (theme) => theme.zIndex.modal + 1,
      }}
    >
      <StyledSpinnerContainer>
        <StyledCircularProgress size={60} thickness={4} />
        <LoadingText>{message}</LoadingText>
      </StyledSpinnerContainer>
    </Backdrop>
  );
};
